import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Furniture extends Page{
    constructor(){
        super({
            id : 'furniture',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}